import useApiQuery from 'shared/hooks/use-api-query';
import {AccessControlProps} from 'modules/access-controls/types';
import citiesKeys from '../util/cities-keys';

const useCityAccessControls = (cityId: string) => {
  return useApiQuery<AccessControlProps[]>({
    url: `/access-controls/cities/${cityId}`,
    queryKey: citiesKeys.accessControls(cityId),
  });
};

export default useCityAccessControls;
